module.exports = __webpack_public_path__ + "static/media/cards-light.26367209.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cards-light.svg
// module id = 170
// module chunks = 0